<template>
  <div class="sc-message--content received carousel flex">
    <div class="sc-message--text sc-message-bubble received rounded-tl-none"
         :style="styles.message"
    >
      <p :style="styles.text"
         class="sc-message--text-content"
      >
        {{ text }}
      </p>
      <div v-if="showButton"
           class="sc-message--struct-buttons mt-2 flex flex-col"
      >
        <div class="button border-none w-full my-0.5 font-inherit no-underline text-center hover:cursor-pointer"
             :style="styles.button"
        >
          <span class="button-text">
            Send us email
          </span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'BotMessages',

  props: {
    themeConfig: {
      type: Object,
      required: true
    },
    showButton: {
      type: Boolean,
      default: false
    },
    text: {
      type: String,
      default: 'How can I help you?'
    }
  },

  computed: {
    styles() {
      return {
        message: {
          opacity: 1,
          background: this.themeConfig.receivedMessage.bg,
          color: this.themeConfig.receivedMessage.text,
          marginRight: this.themeConfig.receivedMessage.marginRight,
          fontSize: this.themeConfig.messageBubble.fontSize,
          fontWeight: this.themeConfig.messageBubble.fontWeight,
          lineHeight: this.themeConfig.messageBubble.lineHeight,
          padding: this.themeConfig.messageBubble.paddingText,
          paddingStruct: this.themeConfig.messageBubble.paddingStruct,
          width: this.themeConfig.messageBubble.width
        },
        button: {
          '--button-bg': this.themeConfig.sentMessage.button.bg,
          '--button-bg-hover': this.themeConfig.sentMessage.button.bgHover,
          fontSize: this.themeConfig.messageBubble.fontSize,
          fontWeight: this.themeConfig.messageBubble.fontWeight,
          border: this.themeConfig.sentMessage.button.border,
          '--button-text': this.themeConfig.sentMessage.button.text,
          '--button-text-hover': this.themeConfig.sentMessage.button.textHover,
          fontFamily: this.themeConfig.font
        },
        text: {
          fontFamily: this.themeConfig.font
        }
      }
    }
  }
}
</script>
